import React, { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./NavigationBar.css";
import AppLogoSvg from "../assets/images/logoblack.svg";
import CustomBtn from "../components/custom/CustomBtn.js";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, NavDropdown, NavLink } from "react-bootstrap";

const NavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNavbarFixed, setNavbarFixed] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [activeItem, setActiveItem] = useState("");


  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setActiveItem("Home");
        break;
      case "/about-us":
        setActiveItem("AboutUs");
        break;
      case "/contact-us":
        setActiveItem("ContactUs");
        break;
      case "/how-it-works":
        setActiveItem("HowItWorks");
        break;
      default:
        setActiveItem("");
        break;
    }
  }, [location.pathname]);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const threshold = 100;

      if (scrollPosition > threshold) {
        setNavbarFixed(true);
      } else {
        setNavbarFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigateToPage = (pageName) => {

    switch (pageName) {
      case "HowItWorks":
        navigate("/how-it-works");
        window.scrollTo(0, 0);
        setExpanded(false);
        break;
      case "AboutUs":
        navigate("/about-us");
        window.scrollTo(0, 0);
        setExpanded(false);
        break;
      case "ContactUs":
        navigate("/contact-us");
        window.scrollTo(0, 0);
        setExpanded(false);
        break;
      case "Home":
        navigate("/");
        window.scrollTo(0, 0);
        setExpanded(false);
        break;
      default:
        console.warn("Invalid page name provided");
        break;
    }
  };

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="xl"
        expanded={expanded}
        onToggle={handleToggle}
        className={`navBar  ${isNavbarFixed ? "fixed-top" : ""}`}
      >
        <Navbar.Brand
          className="cursor-pointer"
          onClick={() => {
            navigateToPage("Home");
          }}
        >
          <img src={AppLogoSvg} alt="navLogo" className="navlogo " />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" className="" />
        <Navbar.Collapse id="responsive-navbar-nav ">
          <Nav className="me-auto mx-auto d-flex gap-xl-4 px-3">
            {/* <NavLink
              className={activeItem === "Home" ? "active" : "text-black"}
              onClick={() => navigateToPage("Home")}
            >
              Home
            </NavLink> */}
            <NavLink
              className={activeItem === "HowItWorks" ? "active" : "text-black"}
              onClick={() => navigateToPage("HowItWorks")}
            >
              How It Works
            </NavLink>

            <NavLink
              className={activeItem === "AboutUs" ? "active" : "text-black"}
              onClick={() => navigateToPage("AboutUs")}
            >
              About
            </NavLink>

            <NavLink
              className={activeItem === "ContactUs" ? "active" : "text-black"}
              onClick={() => navigateToPage("ContactUs")}
            >
              Contact Us
            </NavLink>
          </Nav>

          <Nav>
            <div
              style={{ textDecoration: "none" }}
              className="d-flex flex-column flex-xl-row align-items-xl-center  mt-2 mt-xl-0 px-2"
            >
              <a href="https://apps.apple.com/us/app/realtybase/id1581598890" target="_blank">
                <button className="btnNow">Download Now</button>
              </a>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default NavigationBar;
